export default __webpack_public_path__ + "static/media/home_white_logo.be878eba.png";